/* Zootii article v2. No dependencies. Deferred. */
(() => {
  const root = document.querySelector('[data-zv]');
  if (!root) return;
  const $ = (s, c = root) => c.querySelector(s);
  const $$ = (s, c = root) => [...c.querySelectorAll(s)];
  const body = $('[data-zv-body]');
  const url = root.dataset.url, title = root.dataset.title, id = root.dataset.id;
  const ls = { get: (k, d) => { try { return JSON.parse(localStorage.getItem(k)) ?? d; } catch (e) { return d; } }, set: (k, v) => { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} } };
  const track = (name, p = {}) => { try { (window.dataLayer = window.dataLayer || []).push({ event: 'zv_' + name, zv_article: title, ...p }); if (window.gtag) gtag('event', 'zv_' + name, p); } catch (e) {} };

  /* toast */
  const toastEl = $('[data-zv-toast]'); let tt;
  const toast = (msg, btn, fn) => {
    toastEl.textContent = msg;
    if (btn) { const b = document.createElement('button'); b.type = 'button'; b.textContent = btn; b.onclick = fn; toastEl.append(b); }
    toastEl.classList.add('is-on'); clearTimeout(tt); tt = setTimeout(() => toastEl.classList.remove('is-on'), 3200);
  };

  /* progress + dock */
  const bar = $('[data-zv-progress] span'), dock = $('[data-zv-dock]'), actions = $('[data-zv-actions]');
  let ticking = false;
  const onScroll = () => {
    if (ticking) return; ticking = true;
    requestAnimationFrame(() => {
      const r = body.getBoundingClientRect(), h = r.height - innerHeight * 0.6;
      bar.style.transform = `scaleX(${Math.min(1, Math.max(0, -r.top / (h > 0 ? h : 1)))})`;
      ticking = false;
    });
  };
  addEventListener('scroll', onScroll, { passive: true }); onScroll();
  new IntersectionObserver(([e]) => dock.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0)).observe(actions);

  /* TOC: open on desktop, highlight current section */
  const toc = $('[data-zv-toc]');
  if (toc) {
    const mq = matchMedia('(min-width:1100px)'); const sync = () => { if (mq.matches) toc.open = true; }; sync(); mq.addEventListener('change', sync);
    const links = new Map($$('a', toc).map((a) => [decodeURIComponent(a.hash.slice(1)), a]));
    const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { links.forEach((a) => a.classList.remove('is-on')); links.get(e.target.id)?.classList.add('is-on'); } }), { rootMargin: '-15% 0px -75% 0px' });
    $$('h2[id]', body).forEach((h) => io.observe(h));
    $('[data-zv-toc-open]')?.addEventListener('click', () => { toc.open = true; toc.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
    toc.addEventListener('click', (e) => { if (e.target.closest('a') && !mq.matches) toc.open = false; });
  }

  /* LIKE: localStorage + optional base count from metafield custom.likes */
  const likeKey = 'zv_like_' + id, base = +root.dataset.likes || 0;
  const paintLike = () => { const on = ls.get(likeKey, false); const n = base + (on ? 1 : 0);
    $$('[data-zv-like]').forEach((b) => b.setAttribute('aria-pressed', on)); $$('[data-zv-like-n]').forEach((s) => (s.textContent = n > 0 ? n : '')); };
  $$('[data-zv-like]').forEach((b) => b.addEventListener('click', () => {
    const on = !ls.get(likeKey, false); ls.set(likeKey, on); paintLike();
    if (on) { b.classList.remove('zv-pop'); void b.offsetWidth; b.classList.add('zv-pop'); toast('Thank you! Glad it helped.'); track('like'); }
  }));
  paintLike();

  /* SAVE: list of posts in localStorage "zv_saved" */
  const savedSheet = $('[data-zv-saved-sheet]');
  const saved = () => ls.get('zv_saved', []);
  const isSaved = () => saved().some((p) => p.url === url);
  const paintSave = () => { const on = isSaved(); $$('[data-zv-save]').forEach((b) => b.setAttribute('aria-pressed', on)); $$('[data-zv-saved-n]').forEach((s) => (s.textContent = saved().length ? '(' + saved().length + ')' : '')); };
  const renderSaved = () => {
    const ul = $('[data-zv-saved-list]'); ul.innerHTML = '';
    const list = saved();
    if (!list.length) { ul.innerHTML = '<li>Nothing saved yet. Tap the bookmark on any post.</li>'; return; }
    list.forEach((p) => { const li = document.createElement('li');
      li.innerHTML = `${p.img ? `<img src="${p.img}" alt="" width="64" height="48" loading="lazy">` : ''}<a></a><button type="button">Remove</button>`;
      li.querySelector('a').href = p.url; li.querySelector('a').textContent = p.title;
      li.querySelector('button').onclick = () => { ls.set('zv_saved', saved().filter((x) => x.url !== p.url)); renderSaved(); paintSave(); };
      ul.append(li); });
  };
  const openSaved = () => { renderSaved(); savedSheet.showModal(); };
  $$('[data-zv-save]').forEach((b) => b.addEventListener('click', () => {
    if (isSaved()) { ls.set('zv_saved', saved().filter((p) => p.url !== url)); toast('Removed from saved posts'); }
    else { ls.set('zv_saved', [{ url, title, img: root.dataset.img, at: Date.now() }, ...saved()].slice(0, 50)); toast('Saved for later', 'View', openSaved); track('save'); }
    paintSave();
  }));
  $$('[data-zv-saved-open]').forEach((b) => b.addEventListener('click', openSaved));
  paintSave();

  /* SHARE */
  const shareSheet = $('[data-zv-share-sheet]'), nativeBtn = $('[data-zv-native]');
  if (navigator.share) nativeBtn.hidden = false;
  const nativeShare = () => navigator.share({ title, text: title, url: url + '?utm_source=native_share&utm_medium=social&utm_campaign=blog_share' }).then(() => track('share', { method: 'native' })).catch(() => {});
  nativeBtn.addEventListener('click', nativeShare);
  $$('[data-zv-share-open]').forEach((b) => b.addEventListener('click', () => shareSheet.showModal()));
  $$('[data-zv-close]').forEach((b) => b.addEventListener('click', () => b.closest('dialog').close()));
  $$('dialog').forEach((d) => d.addEventListener('click', (e) => { if (e.target === d) d.close(); }));
  root.addEventListener('click', (e) => {
    const c = e.target.closest('[data-zv-copy]');
    if (c) { const u = c.dataset.zvCopy + '?utm_source=copy_link&utm_medium=social&utm_campaign=blog_share';
      (navigator.clipboard ? navigator.clipboard.writeText(u) : Promise.reject()).then(() => toast('Link copied. Paste it in your group chat.'), () => prompt('Copy this link', u)); track('share', { method: 'copy' }); return; }
    const t = e.target.closest('[data-zv-track]');
    if (t) track(t.matches('.zv-cta') ? 'community_click' : 'share', { method: t.dataset.zvTrack });
    const p = e.target.closest('[data-zv-pending]');
    if (p) { e.preventDefault(); toast('Opening soon. We are setting up the group.'); }
  });

  /* CAROUSELS: arrows, dots, counter (space reserved by .zv-car-nav height) */
  $$('.zv-carousel', body).forEach((car) => {
    const items = [...car.children]; if (items.length < 2) return;
    const nav = document.createElement('div'); nav.className = 'zv-car-nav'; nav.setAttribute('data-zv-skip', '');
    nav.innerHTML = `<div class="zv-dots" aria-hidden="true">${items.map(() => '<i></i>').join('')}</div><span class="zv-car-count" aria-live="polite"></span><div class="zv-car-btns"><button type="button" aria-label="Previous">&lsaquo;</button><button type="button" aria-label="Next">&rsaquo;</button></div>`;
    car.after(nav);
    const dots = [...nav.querySelectorAll('.zv-dots i')], count = nav.querySelector('.zv-car-count');
    const step = () => items[0].getBoundingClientRect().width + 12;
    const idx = () => Math.min(items.length - 1, Math.round(car.scrollLeft / step()));
    const paint = () => { const i = idx(); dots.forEach((d, j) => d.classList.toggle('is-on', j === i)); count.textContent = `${i + 1} / ${items.length}`; };
    const [prev, next] = nav.querySelectorAll('button');
    prev.onclick = () => car.scrollBy({ left: -step(), behavior: 'smooth' });
    next.onclick = () => car.scrollBy({ left: step(), behavior: 'smooth' });
    car.addEventListener('scroll', () => requestAnimationFrame(paint), { passive: true }); paint();
    let swiped = false; car.addEventListener('scroll', () => { if (!swiped) { swiped = true; track('carousel_swipe'); } }, { passive: true });
  });

  /* INFOGRAPHIC share buttons (absolute, no layout shift) */
  $$('.zv-info', body).forEach((f) => {
    const img = f.querySelector('img'); if (!img) return;
    const src = (img.currentSrc || img.src).split('?')[0];
    const anchor = f.id || (f.id = 'info-' + Math.random().toString(36).slice(2, 7));
    const u = encodeURIComponent(url + '?utm_source=whatsapp&utm_medium=social&utm_campaign=infographic_share#' + anchor);
    const w = document.createElement('div'); w.className = 'zv-info-sh'; w.setAttribute('data-zv-skip', '');
    w.innerHTML = `<a href="https://wa.me/?text=${encodeURIComponent((img.alt || title) + ' ')}${u}" target="_blank" rel="noopener" aria-label="Share on WhatsApp" data-zv-track="infographic_whatsapp">${$('.zv-sh--wa svg').outerHTML}</a><a href="https://pinterest.com/pin/create/button/?url=${encodeURIComponent(url)}&media=${encodeURIComponent(src)}&description=${encodeURIComponent(img.alt || title)}" target="_blank" rel="noopener" aria-label="Save to Pinterest" data-zv-track="infographic_pinterest">${$('.zv-sh--pin svg').outerHTML}</a>`;
    f.append(w);
  });

  /* LISTEN: Web Speech API (en-IN first) or MP3 from metafield */
  const plays = $$('[data-zv-play]'), status = $('[data-zv-status]'), speedBtn = $('[data-zv-speed]'), stopBtn = $('[data-zv-stop]');
  const audioUrl = plays[0].dataset.audio, synth = window.speechSynthesis;
  if (!audioUrl && !synth) { plays.forEach((b) => (b.hidden = true)); }
  const speeds = [1, 1.25, 1.5, 0.75]; let si = 0, blocks = [], bi = 0, state = 'idle', voice, audio;
  const pickVoice = () => { const v = synth.getVoices(); const en = v.filter((x) => /^en/i.test(x.lang));
    return en.find((x) => /en-IN/i.test(x.lang) && /natural|neural|online/i.test(x.name)) || en.find((x) => /en-IN/i.test(x.lang)) || en.find((x) => /india/i.test(x.name)) || en.find((x) => /en-GB/i.test(x.lang)) || en[0] || v[0]; };
  if (synth) { voice = pickVoice(); synth.onvoiceschanged = () => (voice = pickVoice()); }
  const collect = () => $$('h2,h3,p,li,blockquote,figcaption,summary', body).filter((el) => !el.closest('[data-zv-skip]') && !(el.matches('p') && el.closest('li,blockquote')) && el.textContent.trim().length > 1);
  const setUI = () => { const on = state === 'playing';
    plays.forEach((b) => b.setAttribute('aria-pressed', on)); dock.classList.toggle('is-playing', state !== 'idle');
    status.textContent = state === 'idle' ? status.dataset.idle : (on ? 'Reading ' : 'Paused ') + (bi + 1) + ' of ' + blocks.length; };
  status.dataset.idle = status.textContent;
  const mark = (el) => { $$('.zv-reading', body).forEach((x) => x.classList.remove('zv-reading')); if (!el) return; el.classList.add('zv-reading');
    const r = el.getBoundingClientRect(); if (r.top < 70 || r.bottom > innerHeight - 100) el.scrollIntoView({ behavior: 'smooth', block: 'center' }); };
  const speak = () => {
    if (bi >= blocks.length) { stop(); return; }
    const el = blocks[bi]; mark(el); const d = el.closest('.zv-faq-i'); if (d) d.open = true;
    const u = new SpeechSynthesisUtterance(el.textContent.replace(/\s+/g, ' ').trim());
    if (voice) { u.voice = voice; u.lang = voice.lang; } else u.lang = 'en-IN';
    u.rate = speeds[si];
    u.onend = () => { if (state === 'playing' && u === cur) { bi++; speak(); } };
    cur = u; synth.speak(u); setUI();
  };
  let cur;
  const play = () => {
    if (audioUrl) { audio = audio || new Audio(audioUrl); audio.playbackRate = speeds[si]; audio.play(); state = 'playing'; setUI(); audio.onended = stop; return; }
    if (state === 'paused') { state = 'playing'; synth.cancel(); speak(); return; }
    blocks = collect(); bi = 0;
    const visible = blocks.findIndex((el) => el.getBoundingClientRect().top > 60); if (visible > 0 && scrollY > innerHeight) bi = visible;
    state = 'playing'; synth.cancel(); speak(); track('listen_start');
  };
  const pause = () => { state = 'paused'; if (audio) audio.pause(); else synth.cancel(); setUI(); };
  function stop() { state = 'idle'; if (audio) { audio.pause(); audio.currentTime = 0; } else if (synth) synth.cancel(); mark(null); setUI(); }
  plays.forEach((b) => b.addEventListener('click', () => (state === 'playing' ? pause() : play())));
  speedBtn.addEventListener('click', () => { si = (si + 1) % speeds.length; speedBtn.textContent = speeds[si] + 'x'; if (audio) audio.playbackRate = speeds[si]; else if (state === 'playing') { synth.cancel(); speak(); } });
  stopBtn.addEventListener('click', stop);
  addEventListener('pagehide', () => synth && synth.cancel());
  root.zvListen = { state: () => ({ state, bi, total: blocks.length, voice: voice && voice.name, lang: voice && voice.lang, reading: $('.zv-reading', body)?.textContent.slice(0, 60) }), pause, stop };

  /* Reveal figures that start below the fold (never above-the-fold content) */
  if (!matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
    const els = $$('.zv-info,.zv-stats,.zv-pull,.zv-community,.zv-products', body).filter((el) => el.getBoundingClientRect().top > innerHeight);
    const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('zv-in'); e.target.classList.remove('zv-pre'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -8% 0px' });
    els.forEach((el) => { el.classList.add('zv-pre'); io.observe(el); });
  }
})();
